
define('text!plugins/author/setupTemplate.html',[],function () { return '';});

